
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { Organization } from 'types'

export const getEnrichedOrganizations = async (): Promise<Organization[] | []> => {
  try {
    const url = `${baseUrl}/aws/organizations/metrics/deals`
    const { data } = await axios.get(url)
    return data || []
  } catch (error) {
    console.error('Error fetching organizations:', error)
    return []
  }
}

export const useEnrichedOrganizations = (enabled: boolean = true) => {
  const { data, isLoading, isError }: UseQueryResult<Organization[] | []> = useQuery({
    queryKey: ['organizationMetrics'],
    queryFn: getEnrichedOrganizations,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 10,
    enabled,
  })

  return {
    enrichedOrganizations: data || [],
    isEnrichedOrganizationsLoading: isLoading,
    isEnrichedOrganizationsError: isError,
  }
}
